import { defineMessages } from "react-intl";

const PREFIX = "RegisterPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Password Reset Form",
  },
  changeButton: {
    id: `${PREFIX}.change`,
    defaultMessage: "Change",
  },
  errorMessage: {
    id: `${PREFIX}.errorMessage`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  newPassword: {
    id: `${PREFIX}.newPassword`,
    defaultMessage: "New password",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },
  fieldIsRequired: {
    id: `${PREFIX}.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  passwordsMustMatch: {
    id: `${PREFIX}.passwordsMustMatch`,
    defaultMessage: "New password and its confirmation must match",
  },
  checkCorrectness: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  passwordLengthError: {
    id: `${PREFIX}.passwordLengthError`,
    defaultMessage:
      "The password must contain at least eight characters, lowercase and uppercase letters, numbers, and special characters",
  },
  serverError: {
    id: `${PREFIX}.serverError`,
    defaultMessage: "Sorry, something went wrong. Please try later",
  },
  passwordsIdentityError: {
    id: `${PREFIX}.passwordsIdentityError`,
    defaultMessage: "New password must be different from the current password",
  }
});
